import {HttpErrorResponse, HttpRequest} from '@angular/common/http';

const secretKey = /authorization|cookie|password|secret|token|api[-_]?key/i;

function sanitize(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sanitize);
  if (value && typeof value === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, entry] of Object.entries(value)) {
      result[key] = secretKey.test(key) ? '[redacted]' : sanitize(entry);
    }
    return result;
  }
  if (typeof value === 'string') {
    return value.replace(/Bearer\s+[^\s"<]+/gi, 'Bearer [redacted]')
      .replace(/((?:token|password|secret|api[_-]?key)[\w-]*["']?\s*[:=]\s*["']?)[^\s"'&,}]+/gi, '$1[redacted]');
  }
  return value;
}

export function apiErrorDetails(request: HttpRequest<unknown>, error: HttpErrorResponse): string {
  // Do not collect request headers/body or query values: QR tokens and credentials may be present.
  const url = request.urlWithParams.split(/[?#]/)[0];
  return JSON.stringify(sanitize({
    time: new Date().toISOString(), method: request.method, url,
    status: error.status, statusText: error.statusText,
    message: error.message.split(/[?#]/)[0],
    requestId: error.headers.get('x-request-id') ?? error.headers.get('x-correlation-id'),
    response: error.error instanceof ProgressEvent ? {type: error.error.type} : error.error,
  }), null, 2).slice(0, 16000);
}
